import * as Yup from 'yup';

export const addUserSchema = Yup.object().shape({
  email: Yup.string().email('Invalid E-mail').required('E-mail is required'),
});
